import echarts from "echarts";
import _ from "loadsh";

import { textLength, tripartite } from "@/assets/js/until";
const colorList = [
  "#36CBCB",
  "#2051F5",
  "#91c7ae",
  "#18D070",
  "#FAD337",
  "#d48265",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#61a0a8",
];
const healthColorList = [
  "#9B2800",
  "#C53A09",
  "#E85420",
  "#F7B500",
  "#E1E700",
  "#A4D90F",
  "#6DD400",
];

// --------------------改变大小部分---------------------------
let echartsList = {};
let timeOutCache;
let resizeFun = () => {
  if (timeOutCache) clearTimeout(timeOutCache);
  timeOutCache = setTimeout(() => {
    for (let i in echartsList) {
      try {
        if (_.get(echartsList, "[ i ].resize")) echartsList[i].resize();
        if (echartsList.resChart)
          setTimeout(() => echartsList.resChart.resize(), 100); // 防止执行时宽度错误
      } catch (error) {
        console.log("改变大小失败：" + error);
      }
    }
  }, 400);
};

export function resize() {
  window.addEventListener("resize", resizeFun);
}

export function delResize() {
  window.removeEventListener("resize", resizeFun);
}

// ------------------------------通用参数部分---------------------------------
const pieRich = {
  a: {
    color: "#1890ff",
    fontSize: 12,
    fontWeight: "normal",
  },
  b: {
    color: "#444",
    fontSize: 24,
    fontWeight: "normal",
  },
  c: {
    color: "#444",
    fontSize: 18,
    fontWeight: "normal",
  },
  d: {
    color: "#444",
    fontSize: 16,
    fontWeight: "normal",
  },
};

// // 用户数据-身份分部-饼图
export function createPie(data) {
  // 基于准备好的dom，初始化echarts实例
  let myChart = (echartsList.userChart = echarts.init(
    document.getElementById("userChart")
  ));
  //自适应大小
  window.addEventListener("resize", () => {
    myChart.resize();
  });

  if (data && data[0]) {
    var all = 0;
    // 获取总数
    data.forEach((e) => (all += e.value));
  }
  // 指定图表的配置项和数据
  let option = {
    legend: [
      {
        orient: "vertical",
        right: "-5%",
        top: "40px",
        itemGap: 30,
        itemWidth: 3,
        formatter: (name) => {
          let d;
          if (data && data.length) {
            data.forEach((item) => {
              if (item.name === name) {
                d = item;
              }
            });
          }
          if (!d) return " ";
          let b = (d.percentage || 0) + "%";
          return `  {a|${name}}\n{b|${b}}`;
        },
        textStyle: {
          lineHeight: 22,
          fontSize: 14,
          padding: [0, 0, -24, -10],
          rich: {
            a: {
              color: "#666666",
            },
            b: {
              color: "#999999",
            },
          },
        },
      },
    ],
    title: {
      text: "身份分布",
      textStyle: {
        color: "#666",
        fontSize: 14,
        fontWeight: "normal",
      },
    },
    tooltip: {},
    color: colorList,
    series: [
      {
        left: 60,
        bottom: 10,
        type: "pie",
        radius: ["50%", "70%"], //线条宽度
        itemStyle: {
          borderColor: "#fff",
          borderWidth: 2,
        },
        avoidLabelOverlap: true,
        hoverAnimation: false,
        label: {
          show: false,
        },
        center: ["30%", "60%"],
        data: data,
        labelLine: {
          length2: 2,
        },
        label: {
          // alignTo: 'labelLine',
          formatter: (e) => {
            return `${e.data.name}: ${tripartite(e.data.value)}`;
          },
        },
      },
      {
        left: 60,
        bottom: 10,
        type: "pie",
        color: "#ffffff",
        radius: [0, 0], //线条宽度
        center: ["30%", "60%"],
        data: [
          {
            value: all,
            name: "总计",
          },
        ],
        label: {
          // 是显示标签
          show: true,
          position: "center",
          color: "#fff",
          lineHeight: 15,
          formatter: () => {
            let long = (all + "").length;
            let type = "b";
            if (long > 9) {
              type = "d";
            } else if (long > 5) {
              type = "c";
            }
            return `{a|总计}` + "\n\n" + `{${type}|${tripartite(all || 0)}}`;
          },
          rich: pieRich,
        },
      },
    ],
  };

  // 使用刚指定的配置项和数据显示图表。
  myChart.setOption(option);
  return myChart;
}

// 用户数据-年龄性别分布-柱状图
export function createBar(data) {
  let ageAndGenderInfo = [
    // 提示信息（按照index展示）
    "18岁以下",
    "18(含)-25(含)",
    "26(含)-35(含)",
    "36(含)-45(含)",
    "46(含)-55(含)",
    "56(含)-65(含)",
    "65以上",
    "无年龄信息",
  ];
  if (
    !_.get(data, "series") ||
    Object.prototype.toString.call(_.get(data, "series")) !== "[object Map]"
  )
    data.series = new Map(); // 兜底
  // 基于准备好的dom，初始化echarts实例
  let myChart = (echartsList.genderChart = echarts.init(
    document.getElementById("genderChart")
  ));
  // 获取总数
  window.addEventListener("resize", () => {
    myChart.resize();
  });
  let allNumber = 0;
  let series = []; // series
  data.series.forEach((item, name) => {
    if (_.get(item, "length")) item.forEach((e) => (allNumber += e));
    series.push({
      name,
      type: "bar",
      stack: "Ad",
      data: item,
      barWidth: 24,
    });
  });

  // 指定图表的配置项和数据
  let option = {
    title: {
      text: "年龄性别分布",
      textStyle: {
        color: "#666",
        fontSize: 14,
        fontWeight: "normal",
      },
    },
    color: colorList,
    legend: {
      orient: "horizontal",
      itemWidth: 8,
      itemHeight: 8,
      right: 0,
      top: -4,
      formatter: (name) => {
        let d;
        let all = 0;
        if (_.get(data, "series")) {
          d = data.series.get(name);
        }
        if (!d) return "";
        d.forEach((e) => (all += e));
        return `${name}(${tripartite(all)}人 ${
          ((all / allNumber) * 100 || 0).toFixed(2) + "%"
        })`;
      },
      textStyle: {
        lineHeight: 22,
        fontSize: 14,
        color: "#666666",
      },
    },
    grid: {
      top: 52,
      left: 0,
      right: 0,
      bottom: 0,
      containLabel: true,
    },
    tooltip: {
      formatter: (e) => {
        let str = "";
        data.series.forEach((item, name) => {
          str += `${name}：${tripartite(item[e.dataIndex])}<br/>`;
        });
        return str + ageAndGenderInfo[e.dataIndex];
      },
      position: (point) => [point[0], "100%"],
    },
    xAxis: {
      type: "category",
      data: data.ageGroupName,
      nameLocation: "start",
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: "#666666",
        },
      },
    },
    yAxis: {
      type: "value",
      axisLine: {
        show: false,
        lineStyle: {
          color: "#666666",
        },
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          color: "#E2E2E2",
          type: "dashed",
        },
      },
      axisLabel: {
        color: "#444343",
        formatter: function (value, index) {
          // value大于1000时除以1000并拼接k，小于1000按原格式显示
          if (value >= 1000) {
            value = value / 1000 + "k";
          } else if (value < 1000) {
            value;
          }
          return value;
        },
      },
    },

    series,
  };

  // 使用刚指定的配置项和数据显示图表。
  myChart.setOption(option);
  return myChart;
}

// 服务数据-服务使用总粗疏-柱状图
export function createBarService(data) {
  // 基于准备好的dom，初始化echarts实例
  var myChart = (echartsList.serviceChart = echarts.init(
    document.getElementById("serviceChart")
  ));
  window.addEventListener("resize", () => {
    myChart.resize();
  });

  // 指定图表的配置项和数据
  var option = {
    title: {
      text: "服务使用总数",
      top: 0,
      textStyle: {
        color: "#666",
        fontSize: 14,
        fontWeight: "normal",
      },
    },
    tooltip: {
      formatter: `{b}<br/>次数:{c}`,
      position: (point) => [point[0], "100%"],
    },
    dataZoom: {
      show: _.get(data, "x.length") ? true : false,
      type: "slider",
      height: 20, // 表示滚动条的高度，也就是粗细
      left: 80,
      right: 80,
      y: 200,
      x: 60,
      fillerColor: "#ECECEC",
      handleSize: "100%",
      showDataShadow: false,
    },
    grid: {
      top: 52,
      left: 10,
      right: 32,
      bottom: _.get(data, "x.length") ? 30 : 0,
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: data.x,
      nameLocation: "start",
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: "#666666",
        },
      },
    },
    yAxis: {
      type: "value",
      axisLine: {
        show: false,
        lineStyle: {
          color: "#666666",
        },
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          color: "#E2E2E2",
          type: "dashed",
        },
      },
    },
    color: ["#2051F5"],
    series: [
      {
        type: "bar",
        data: data.series,
        barWidth: 24,
      },
    ],
  };

  // 使用刚指定的配置项和数据显示图表。
  myChart.setOption(option);
  return myChart;
}

export function drawHealthChart(data) {
  // 基于准备好的dom，初始化echarts实例
  var myChart = (echartsList.healthChart = echarts.init(
    document.getElementById("healthChart")
  ));

  window.addEventListener("resize", () => {
    myChart.resize();
  });
  // 指定图表的配置项和数据
  var option = {
    title: {
      text: "健康状态分布",
      top: 0,
      textStyle: {
        color: "#666",
        fontSize: 14,
        fontWeight: "normal",
      },
    },
    tooltip: {
      position: (point) => [point[0], "100%"],
    },

    color: healthColorList,
    grid: {
      top: 52,
      left: 10,
      right: 32,
      bottom: 0,
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: data.x,
      nameLocation: "start",
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: "#666666",
        },
      },
    },
    // 坐标轴标签
    yAxis: {
      show: true,
      splitLine: {
        show: true, //---是否显示，'category'类目轴不显示，此时我的y轴为类目轴，splitLine属性是有意义的
        lineStyle: {
          color: "#E2E2E2",
          width: 1,
          type: "dashed", //---类型
        },
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        //---坐标轴 刻度
        show: false,
      },
      axisLabel: {
        color: "#444343",
        formatter: function (value, index) {
          // value大于1000时除以1000并拼接k，小于1000按原格式显示
          if (value >= 1000) {
            value = value / 1000 + "k";
          } else if (value < 1000) {
            value;
          }
          return value;
        },
      },
    },
    series: [
      {
        type: "bar",
        data: data.series, // 每行数据的大小
        barWidth: 24, // 宽度
      },
    ],
  };
  // 使用刚指定的配置项和数据显示图表。
  myChart.setOption(option);
  return myChart;
}

// // 核保数据-两图通用-饼图
export function createPieAuto(domId, title, data) {
  // 基于准备好的dom，初始化echarts实例
  let myChart = (echartsList[domId] = echarts.init(
    document.getElementById(domId)
  ));
  window.addEventListener("resize", () => {
    myChart.resize();
  });
  var all = 0;
  if (data && data[0]) {
    // 获取总数
    data.forEach((e) => (all += e.value * 1));
    // 计算百分比
    if (!data[0].percentage) {
      data.forEach((item) => {
        item.percentage =
          ((item.value / all) * 100).toFixed(2) == "NaN"
            ? "0%"
            : ((item.value / all) * 100).toFixed(2) + "%";
      });
    }
  }
  // 指定图表的配置项和数据
  let option = {
    legend: {
      selectedMode: false,
      orient: "vertical",
      right: 20,
      top: "60px",
      itemGap: 60,
      itemWidth: 3,
      formatter: (name) => {
        let d;
        if (_.get(data, "length")) {
          data.forEach((item) => {
            if (item.name === name) {
              d = item;
            }
          });
        }
        if (!d) return " ";
        return `  {a|${name}}\n{b|${d.percentage}}`;
      },
      textStyle: {
        lineHeight: 22,
        fontSize: 14,
        padding: [0, 0, -24, -10],
        rich: {
          a: {
            color: "#666666",
          },
          b: {
            color: "#999999",
          },
        },
      },
    },
    title: {
      text: title,
      textStyle: {
        color: "#666",
        fontSize: 14,
        fontWeight: "normal",
      },
    },
    tooltip: {},
    color: colorList,

    series: [
      {
        left: 40,
        bottom: 10,
        type: "pie",
        radius: ["50%", "70%"], //线条宽度
        itemStyle: {
          borderColor: "#fff",
          borderWidth: 2,
        },
        label: {
          formatter: (e) => {
            return `${e.data.name}: ${tripartite(e.data.value)}`;
          },
        },
        labelLine: {
          length2: 2,
        },
        avoidLabelOverlap: true,
        hoverAnimation: false,
        center: ["30%", "60%"],
        data: data,
      },
      {
        left: 40,
        bottom: 10,
        type: "pie",
        color: "#ffffff",
        radius: [0, 0], //线条宽度
        center: ["30%", "60%"],
        data: [
          {
            value: all,
            name: "总计",
          },
        ],
        label: {
          // 是显示标签
          show: true,
          position: "center",
          color: "#fff",
          lineHeight: 15,
          formatter: () => {
            let long = (all + "").length;
            let type = "b";
            if (long > 9) {
              type = "d";
            } else if (long > 6) {
              type = "c";
            }
            return `{a|总计}` + "\n\n" + `{${type}|${tripartite(all || 0)}}`;
          },
          rich: pieRich,
        },
      },
    ],
  };

  // 使用刚指定的配置项和数据显示图表。
  myChart.setOption(option);
  return myChart;
}
